import { render, staticRenderFns } from "./CampusInfoEdit.vue?vue&type=template&id=09fda558&scoped=true"
import script from "./CampusInfoEdit.vue?vue&type=script&lang=js"
export * from "./CampusInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./CampusInfoEdit.vue?vue&type=style&index=0&id=09fda558&prod&lang=scss"
import style1 from "./CampusInfoEdit.vue?vue&type=style&index=1&id=09fda558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fda558",
  null
  
)

export default component.exports